<script setup>
</script>

<template>
  <section class="section">
    <div class="wrap" style="display:grid; gap: var(--sp-6); max-width: 860px;">
      <h1>Wat zijn de healing technieken van de elementen van Avelon?</h1>

      <div>
        <p>
          In deze zin komen 3 termen voor die ik eerst beter wil uitleggen. Healingtechnieken,
          Elementen, Avelon.
        </p>

        <h3>Avelon</h3>
        <p>
          Misschien denk je bij de term Avelon aan Arthur en de ridders van de Ronde tafel en
          Merlijn en Morgane. En alle andere boeken etc die erover zijn geschreven.
        </p>
        <p>
          Voor mij is Avelon EN een waarachtig, werkelijke plek (een "mythisch" onzichtbaar eiland
          dat in de buurt van de Tor in Glastonbury, Engeland ligt) EN een symbolische plek in onze
          spiritualiteit. De plek waar vrouwelijke en mannelijke energieën samensmelten tot een
          nieuw iets (en wat dat iets is mag je zelf benoemen)
        </p>

        <h3>Elementen</h3>
        <p>
          In de oud-Europese teksten praten sjamanen, druiden, wijzen over de 4 natuurlijke elementen
          als een manier om de wereld te duiden. Namelijk: Aarde, Water, Vuur en Lucht. Deze elementen
          hebben hun eigen krachten, hun eigen kwaliteiten en kunnen afzonderlijk en gemixt speciale
          dingen doen.
        </p>

        <h3>Healingtechnieken</h3>
        <p>
          Het Nederlandse woord van healing is genezing. En het woord genezing wordt in het westen
          vaak gezien als een passief woord. De/Het Ander doet iets voor een wezen en daardoor
          "geneest" dat wezen van iets. Voor mij staat het woord healing als een actief woord, een
          "werk-woord". Degene die de techniek toepast gaat SAMEN met de ander een proces aan. Maar
          de techniek-gever is in mijn optiek alleen maar een doorgeefluik.
        </p>
        <p>
          De Master/Teacher-techniek om met de 4 elementen anderen te ondersteunen in hun eigen
          healing zijn door een druide van Avelon overgedragen aan Tessa, voordat hij zijn aardse
          lichaam verliet en Tessa bracht het op haar beurt weer over aan Gabrielle, voordat Tessa
          haar aardse lichaam verliet. Gabrielle heeft, onder andere, mij ingewijd om de
          healingtechnieken toe te passen. Maar niet om andere mensen in te wijden. Ik ben wel een
          Master Of Healing Elements of Avelon, maar niet de Master/Teacher.
        </p>
      </div>

      <aside class="soft-note">
        <p>
          <strong>Let op!</strong> Door het ontvangen van een elementen heling kan je (zelf)
          bewustzijn worden vergroot en verhoogt het de kans op persoonlijke transformatie met
          innerlijke vrede en vreugde ten gevolge.
        </p>
      </aside>

      <div class="page-tail">
        <p class="read-also">
          <span class="k">Lees ook:</span>
          <router-link to="/wat-is-reiki" class="jargon-link">Wat is Reiki?</router-link> ·
          <router-link to="/wat-is-leela" class="jargon-link">Leela</router-link>
        </p>
        <div class="actions">
          <router-link class="btn btn-primary" to="/contact-2">Vrijblijvend kennismaken</router-link>
          <router-link class="btn btn-ghost" to="/spirituele-coaching">Naar spirituele coaching</router-link>
        </div>
      </div>
    </div>
  </section>
</template>
